import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";

import Home from "./components/home/Home";

const About = lazy(() => import("./components/About/About"));
const Contact = lazy(() => import("./components/ContactUs/Contact"));
const ViewProduct = lazy(() => import("./components/pages/ViewProduct"));
const Product = lazy(() => import("./components/pages/Product"));
const SizeChart = lazy(() => import("./components/SizeChart/SizeChart"));

const PageFallback = () => (
	<div className="flex min-h-[40vh] items-center justify-center" role="status">
		<div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-pink-700" />
		<span className="sr-only">Loading page</span>
	</div>
);

function App() {
	return (
		<Router>
			<Suspense fallback={<PageFallback />}>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/size-chart/:category" element={<SizeChart />} />
					<Route path="/about" element={<About />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/:category/:year" element={<Product />} />
					<Route path="/product/id/:style" element={<ViewProduct />} />
				</Routes>
			</Suspense>
		</Router>
	);
}

export default App;
